import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import ElementsLayout from './components/ElementsLayout';
import ElementNotFound from './components/ElementNotFound';
import ElementLoader from './components/ElementLoader';

// Lazy load components for better performance
const ProctorSchedule = lazy(() => import('./components/ProctorSchedule'));
const SessionViewer = lazy(() => import('./components/proctoring/SessionViewer'));
const ExamCard = lazy(() => import('./components/ExamCard'));
const BlockKitRenderer = lazy(() => import('./components/blockkit/Renderer'));
const BlockKitPlayground = lazy(() => import('./components/blockkit/Playground'));
const ElementsExamples = lazy(() => import('./components/ElementsExamples'));
const ModalHost = lazy(() => import('./modal-host'));

/**
 * Routes for the Elements app
 * These routes are designed to be loaded in an iframe
 */
function ElementsRoutes() {
  return (
    <Routes>
      <Route element={<ElementsLayout />}>
        {/* Proctoring routes */}
        <Route path="proctoring">
          <Route path="schedule" element={
            <Suspense fallback={<ElementLoader />}>
              <ProctorSchedule />
            </Suspense>
          } />
          <Route path="session-viewer" element={
            <Suspense fallback={<ElementLoader />}>
              <SessionViewer />
            </Suspense>
          } />

          <Route path="exam-card" element={
            <Suspense fallback={<ElementLoader />}>
              <ExamCard />
            </Suspense>
          } />
        </Route>

        {/* BlockKit routes */}
        <Route path="blockkit">
          <Route path="renderer" element={
            <Suspense fallback={<ElementLoader />}>
              <BlockKitRenderer />
            </Suspense>
          } />
          <Route path="builder" element={
            <Suspense fallback={<ElementLoader />}>
              <BlockKitPlayground />
            </Suspense>
          } />
        </Route>

        {/* Examples route */}
        <Route path="examples" element={
          <Suspense fallback={<ElementLoader />}>
            <ElementsExamples />
          </Suspense>
        } />
      </Route>

      {/* Modal host route - outside of ElementsLayout for full control */}
      <Route path="modal-host" element={
        <Suspense fallback={<div>Loading modal...</div>}>
          <ModalHost />
        </Suspense>
      } />

      {/* Catch-all route */}
      <Route path="*" element={<ElementNotFound />} />
    </Routes>
  );
}

export default ElementsRoutes;
